import React from 'react';
import { Button } from '../../components/ui/button';
import { Send, Loader2, Check, Copy, Zap, Stethoscope, Building2, Users } from 'lucide-react';

export const CopilotMatch = ({ assign, assignResult, assigning, copyText, match, matchLoading, sendIntro, sending, sentNote, suggestMatch }) => (
        <div>
          <Button onClick={suggestMatch} disabled={matchLoading} variant="outline" className="w-full text-sm">
            {matchLoading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Stethoscope className="w-4 h-4 mr-2" />}
            Suggest best-fit doctors &amp; hospitals
          </Button>
          {match && (
            <div className="mt-3 space-y-3">
              {match.rationale && <p className="text-xs text-slate-600 dark:text-slate-400 italic">{match.rationale}</p>}
              {(match.doctors || []).length > 0 && (
                <div>
                  <div className="flex items-center gap-1.5 mb-1.5 text-xs font-semibold text-slate-700 dark:text-slate-300">
                    <Users className="w-3.5 h-3.5 text-amber-600" /> Recommended doctors
                  </div>
                  <div className="space-y-1.5">
                    {match.doctors.map((d, i) => (
                      <div key={i} className="rounded-lg border border-slate-200 dark:border-slate-700 p-2.5">
                        <div className="flex items-start justify-between gap-2">
                          <div className="flex-1">
                            <div className="text-sm font-medium text-slate-900 dark:text-slate-100">{d.name}</div>
                            <div className="flex flex-wrap gap-1.5 mt-1">
                              {d.specialization && <span className="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300">{d.specialization}</span>}
                              {d.rating != null && <span className="text-[10px] px-1.5 py-0.5 rounded bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300">★ {d.rating}</span>}
                              {d.consultation_fee != null && <span className="text-[10px] px-1.5 py-0.5 rounded bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300">${d.consultation_fee} fee</span>}
                              {d.experience_years != null && <span className="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300">{d.experience_years}y exp</span>}
                              {Array.isArray(d.languages) && d.languages.length > 0 && <span className="text-[10px] px-1.5 py-0.5 rounded bg-sky-100 dark:bg-sky-900/30 text-sky-700 dark:text-sky-300">{d.languages.join(', ')}</span>}
                            </div>
                            {d.why && <div className="text-[11px] text-slate-500 mt-1">{d.why}</div>}
                          </div>
                          <Button onClick={() => assign('doctor', d.name, `d-${i}`)} disabled={assigning === `d-${i}`}
                            className="h-7 text-xs bg-amber-600 hover:bg-amber-700 text-white shrink-0">
                            {assigning === `d-${i}` ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <><Zap className="w-3.5 h-3.5 mr-1" />Assign</>}
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {(match.hospitals || []).length > 0 && (
                <div>
                  <div className="flex items-center gap-1.5 mb-1.5 text-xs font-semibold text-slate-700 dark:text-slate-300">
                    <Building2 className="w-3.5 h-3.5 text-amber-600" /> Recommended hospitals
                  </div>
                  <div className="space-y-1.5">
                    {match.hospitals.map((h, i) => (
                      <div key={i} className="rounded-lg border border-slate-200 dark:border-slate-700 p-2.5">
                        <div className="flex items-start justify-between gap-2">
                          <div className="flex-1">
                            <div className="text-sm font-medium text-slate-900 dark:text-slate-100">{h.name}</div>
                            <div className="flex flex-wrap gap-1.5 mt-1">
                              {h.city && <span className="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300">{h.city}</span>}
                              {h.rating != null && <span className="text-[10px] px-1.5 py-0.5 rounded bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300">★ {h.rating}</span>}
                              {Array.isArray(h.accreditations) && h.accreditations.length > 0 && <span className="text-[10px] px-1.5 py-0.5 rounded bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300">{h.accreditations.join(', ')}</span>}
                            </div>
                            {h.why && <div className="text-[11px] text-slate-500 mt-1">{h.why}</div>}
                          </div>
                          <Button onClick={() => assign('hospital', h.name, `h-${i}`)} disabled={assigning === `h-${i}`}
                            className="h-7 text-xs bg-amber-600 hover:bg-amber-700 text-white shrink-0">
                            {assigning === `h-${i}` ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <><Zap className="w-3.5 h-3.5 mr-1" />Assign</>}
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {assignResult && (
                <div className="rounded-lg bg-emerald-50 dark:bg-emerald-900/15 border border-emerald-200 dark:border-emerald-800 p-3">
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="text-xs font-semibold text-emerald-700 dark:text-emerald-300 flex items-center gap-1">
                      <Check className="w-3.5 h-3.5" /> Assigned{assignResult.assigned?.doctor ? ` ${assignResult.assigned.doctor}` : ''}{assignResult.assigned?.hospital ? ` ${assignResult.assigned.hospital}` : ''} · intro drafted
                    </span>
                    {assignResult.draft_message && (
                      <div className="flex items-center gap-1.5">
                        <Button onClick={sendIntro} disabled={sending} className="h-6 text-[11px] bg-emerald-600 hover:bg-emerald-700 text-white">
                          {sending ? <Loader2 className="w-3 h-3 animate-spin" /> : <><Send className="w-3 h-3 mr-1" />Send to patient</>}
                        </Button>
                        <Button onClick={() => copyText(assignResult.draft_message)} variant="outline" className="h-6 text-[11px]">
                          <Copy className="w-3 h-3 mr-1" />Copy
                        </Button>
                      </div>
                    )}
                  </div>
                  {assignResult.draft_message && (
                    <div className="text-xs text-slate-700 dark:text-slate-300 whitespace-pre-wrap bg-white/60 dark:bg-slate-800/60 rounded p-2">{assignResult.draft_message}</div>
                  )}
                  {sentNote && <p className="text-[11px] text-emerald-700 dark:text-emerald-300 mt-1.5 flex items-center gap-1"><Check className="w-3 h-3" />{sentNote}</p>}
                </div>
              )}
            </div>
          )}
        </div>
);
